import { Action, ActionType } from "app/pages/EarlyBirdOfferList/actionTypes";
import { EarlyBirdOfferItemDto } from "app/shared/model/EarlyBirdOfferDto";

export function pageLoaded(
    offers: EarlyBirdOfferItemDto[],
    divisionId: number
): Action {
    return {
        type: ActionType.PageLoaded,
        offers,
        divisionId,
    };
}